import type { Brand, Branch } from '../domain/entities';

export function flattenBranches(brands: Brand[]): Branch[] {
  return brands.flatMap((brand) =>
    (brand.branches ?? []).map((branch) => ({
      ...branch,
      brandId: branch.brandId ?? brand.id,
      orgId: branch.orgId ?? brand.orgId,
    })),
  );
}

export function getBranchesForBrand(brands: Brand[], brandId: string): Branch[] {
  return flattenBranches(brands).filter((branch) => branch.brandId === brandId);
}

export function getBranchById(brands: Brand[], branchId: string): Branch | undefined {
  return flattenBranches(brands).find((branch) => branch.id === branchId);
}

export function getBrandByBranchId(brands: Brand[], branchId: string): Brand | undefined {
  const branch = getBranchById(brands, branchId);
  if (!branch) return undefined;
  return brands.find((brand) => brand.id === branch.brandId);
}

export function isBranchSelected(
  branch: Branch,
  assignedBrands: string[] | undefined,
  assignedBranches: string[] | undefined,
): boolean {
  return (assignedBrands ?? []).includes(branch.brandId) || (assignedBranches ?? []).includes(branch.id);
}

export function getBrandSelectionState(
  brand: Brand,
  assignedBrands: string[] | undefined,
  assignedBranches: string[] | undefined,
): { checked: boolean; indeterminate: boolean; selectedBranches: number; totalBranches: number } {
  const branches = brand.branches ?? [];
  const brandSelected = (assignedBrands ?? []).includes(brand.id);
  if (brandSelected) {
    return { checked: true, indeterminate: false, selectedBranches: branches.length, totalBranches: branches.length };
  }

  const selectedBranches = branches.filter((branch) => (assignedBranches ?? []).includes(branch.id)).length;
  if (selectedBranches === 0) {
    return { checked: false, indeterminate: false, selectedBranches: 0, totalBranches: branches.length };
  }

   if (branches.length > 0 && selectedBranches === branches.length) {
    return { checked: true, indeterminate: false, selectedBranches, totalBranches: branches.length };
  }

  return {
    checked: false,
    indeterminate: selectedBranches < branches.length,
    selectedBranches,
    totalBranches: branches.length,
  };
}